import React, { useEffect, useState } from 'react';
import { Typography, Grid, Alert, CircularProgress, Fab } from '@mui/material';

import Snackbar from '@mui/material/Snackbar';
import ReplayTwoToneIcon from '@mui/icons-material/ReplayTwoTone';
import { useTheme } from '@emotion/react';
import LeadDetails from './LeadDetails';
import { green } from '@mui/material/colors';
import { getColorFaseByOrdem } from '../../../utils/crm/getColors';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br.js';
import {
  Box, Stack, TextField, IconButton,
  Paper, Fade, useMediaQuery, Select, MenuItem, Pagination, Chip,
  Dialog, DialogTitle, DialogContent
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { motion } from 'framer-motion';
import LeadsControle from './LeadsControle';
import { formatDateTime } from '../../../utils/crm/formatDateTime';
dayjs.locale('pt-br');

export default function MyLeads({
  account, setShowMyLeads, showMyLeads,
  update, setUpdate, setSnackbar,
  leadsList, setLeadsList, loadMyLeads,
  filteredLeads, setFilteredLeads, snackbar,loading, setLoading
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [showLeadDetails, setShowLeadDetails] = useState(false)

  const [selectLead, setSelectLead] = useState(null)
  const [showLeadsControle, setShowLeadsControle] = useState(false)

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  function procurarLeads(event) {
    const value = event.target.value;
    if (!value) {
      setFilteredLeads(leadsList);
      setPage(0);
      return;
    }

    const filtered = leadsList.filter(lead =>
      lead.nome?.toLowerCase().includes(value.toLowerCase()) ||
      lead.email?.toLowerCase().includes(value.toLowerCase()) ||
      lead.telefone?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredLeads(filtered);
    setPage(0);
  }

  function handleOpenLead(lead) {
    setSelectLead(lead)
    setShowLeadDetails(true)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  useEffect(() => {
    loadMyLeads()
  }, [loadMyLeads])


  return (
    <Dialog
      open={showMyLeads}
      onClose={() => setShowMyLeads(false)}
      maxWidth="xl"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          height: isMobile ? '100vh' : '90vh',
          maxHeight: isMobile ? '100vh' : '90vh',
          m: isMobile ? 0 : 2,
          borderRadius: isMobile ? 0 : 2,
          overflow: 'hidden',
          backgroundColor: 'background.default',
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          borderBottom: 1,
          borderColor: 'divider',
          fontWeight: 'bold',
          fontSize: '1.3rem',
          color: 'white',
        }}
      >
        <Typography variant="h3" noWrap component="div">
          Meus Leads 
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
          }}
        >
          {loading && (
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(4px)',
              zIndex: 9999
            }}>
              <CircularProgress />
            </Box>
          )}

          {!showLeadDetails && !showLeadsControle && (
            <>
              <Stack
                spacing={2}
                sx={{
                  p: 2,
                  bgcolor: 'background.paper',
                  boxShadow: 1,
                  position: 'sticky',
                  top: 0,
                  zIndex: 1000
                }}
              >            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Chip
                      icon={<ViewKanbanIcon />}
                      onClick={() => setShowLeadsControle(true)}
                      clickable
                      variant="outlined"
                      color="primary"
                      sx={{
                        height: 32,
                        width: 32,
                        minWidth: 32,
                        borderRadius: '50%',
                        fontSize: '0.875rem',
                        fontWeight: 'bold',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 0,
                        '& .MuiChip-icon': {
                          margin: 0,
                          fontSize: '1.2rem'
                        },
                        '& .MuiChip-label': {
                          display: 'none'
                        },
                        '&:hover': {
                          backgroundColor: 'primary.light',
                          color: 'white',
                          '& .MuiChip-icon': {
                            color: 'white'
                          }
                        }
                      }}
                    />
                    <Typography variant="h5" color="text.secondary">
                      Total: {leadsList.length}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Buscar lead..."
                    onChange={(e) => procurarLeads(e)}
                    InputProps={{
                      startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
                    }}
                    sx={{ bgcolor: 'background.paper' }}
                  />
                  <IconButton
                    onClick={loadMyLeads}
                    disabled={loading}
                    color="primary"
                    sx={{
                      bgcolor: 'background.paper',
                      '&:hover': { bgcolor: 'action.hover' }
                    }}
                  >
                    <ReplayTwoToneIcon />
                  </IconButton>
                </Stack>
              </Stack>

              <Box sx={{
                flex: 1,
                bgcolor: 'grey.100',
                overflow: 'auto',
                p: 2
              }}>
                <Stack spacing={2}>
                  <Stack spacing={1}>
                    {filteredLeads
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((lead, index) => (
                        <Fade in key={lead.idlead} style={{ transitionDelay: `${index * 30}ms` }}>
                          <Paper
                            component={motion.div}
                            whileHover={{ scale: 1.01 }}
                            onClick={() => handleOpenLead(lead)}
                            elevation={2}
                            sx={{
                              p: 2,
                              cursor: 'pointer',
                              bgcolor: getColorFaseByOrdem(lead.fase.ordem),
                              transition: 'all 0.2s',
                              '&:hover': {
                                bgcolor: green[300],
                                boxShadow: 4
                              }
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={4}>
                                <Stack>
                                  <Typography variant="subtitle1" fontWeight="bold">
                                    {lead.nome}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    {lead.email}
                                  </Typography>
                                </Stack>
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <Stack>
                                  <Typography variant="body2" color="text.secondary">
                                    Fase: {lead.fase.nome}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Etapa: {lead.etapa.nome}
                                  </Typography>
                                </Stack>
                              </Grid>
                              <Grid item xs={12} sm={2}>
                                <Typography variant="body2">
                                  {lead.telefone}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <Typography variant="caption" color="text.secondary">
                                  Criado em: {formatDateTime(lead.createdat)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Fade>
                      ))}
                  </Stack>

                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      bgcolor: 'background.paper'
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      {`${page * rowsPerPage + 1}-${Math.min((page + 1) * rowsPerPage, filteredLeads.length)} de ${filteredLeads.length}`}
                    </Typography>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Select
                        value={rowsPerPage}
                        onChange={handleChangeRowsPerPage}
                        size="small"
                        sx={{
                          display: isMobile ? 'none' : 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <MenuItem value={5}>5 por página</MenuItem>
                        <MenuItem value={10}>10 por página</MenuItem>
                        <MenuItem value={25}>25 por página</MenuItem>
                        <MenuItem value={50}>50 por página</MenuItem>
                      </Select>
                      <Pagination
                        count={Math.ceil(filteredLeads.length / rowsPerPage)}
                        page={page + 1}
                        onChange={(e, p) => handleChangePage(e, p - 1)}
                        color="primary"
                        size={isMobile ? "small" : "medium"}
                      />
                    </Stack>
                  </Paper>
                </Stack>
              </Box>
            </>
          )}

          {showLeadDetails && (
            <LeadDetails
              account={account}
              lead={selectLead}
              setShowMyLeads={setShowMyLeads}
              // setShowMenu={setShowMenu}
              setShowLeadDetails={setShowLeadDetails}
              showLeadDetails={showLeadDetails}
              setSnackbar={setSnackbar}
              setUpdate={setUpdate}
              update={update}
              setLoading={setLoading}
              loading={loading}
            />
          )}

          {showLeadsControle && (
            <>
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{
                  p: 2,
                  bgcolor: 'background.paper',
                  boxShadow: 1,
                  position: 'sticky',
                  top: 0,
                  zIndex: 1000
                }}
              >
                <IconButton
                  onClick={() => setShowLeadsControle(false)}
                  color="primary"
                  sx={{
                    bgcolor: 'background.paper',
                    '&:hover': { bgcolor: 'action.hover' }
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h4" fontWeight="bold" color="primary">
                  Voltar
                </Typography>
              </Stack>
              <Box sx={{ width: '100%', flex: 1, overflow: 'auto' }}>
                <LeadsControle
                  account={account}
                  setSnackbar={setSnackbar}
                  setUpdate={setUpdate}
                  update={update}
                />
              </Box>
            </>
          )}

          {!!snackbar && (
            <Snackbar
              open
              onClose={() => setSnackbar(null)}
              autoHideDuration={4000}
              anchorOrigin={{
                horizontal: 'center',
                vertical: isMobile ? 'top' : 'bottom'
              }}
            >
              <Alert
                severity={snackbar.severity}
                onClose={() => setSnackbar(null)}
                variant="filled"
                elevation={6}
                sx={{ width: '100%' }}
              >
                {snackbar.message}
              </Alert>
            </Snackbar>
          )}
        </Box>
      </DialogContent>
      <Fab
        color="primary"
        aria-label="add"
        onClick={setShowMyLeads.bind(this, false)}
        sx={{
          position: 'absolute',
          left: '6dvw',
          bottom: '2dvh',
          zIndex: 1100,
          display: { xs: 'flex', md: 'none' }
        }}
      >
        <ArrowBackIcon />
      </Fab>
    </Dialog>
  );
}



